import { T } from "@/lib/i18n";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { notificationsApi } from "@/lib/api";

export const NotificationBell = () => {
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const load = () => notificationsApi.list().then(setData).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (!open) return;
    const close = () => setOpen(false);
    window.addEventListener("click", close);
    return () => window.removeEventListener("click", close);
  }, [open]);

  const toggle = async (e) => {
    e.stopPropagation();
    setOpen(!open);
    if (!open && data.unread) {
      await notificationsApi.readAll().catch(() => {});
      setData((d) => ({ ...d, unread: 0 }));
    }
  };

  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      <button data-testid="notification-bell" onClick={toggle} className="relative w-9 h-9 border border-[#e4e4e7] rounded-sm flex items-center justify-center hover:bg-[#f4f4f5]">
        <Bell className="w-4 h-4" />
        {data.unread > 0 && (
          <span data-testid="notification-unread" className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 aurora-gradient text-white text-[10px] font-bold flex items-center justify-center rounded-full">
            {data.unread}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notification-panel" className="absolute right-0 top-11 w-80 bg-white border border-[#e4e4e7] shadow-lg z-50 max-h-96 overflow-y-auto">
          <div className="px-4 py-2.5 border-b border-[#f4f4f5] text-[10px] uppercase tracking-widest font-mono text-[#71717a]">{T("Notifiche")}</div>
          {data.notifications.map((n) => (
            <Link key={n.id} to={`/campaign/${n.campaign_id}`} onClick={() => setOpen(false)}
              className={`block px-4 py-3 border-b border-[#f4f4f5] hover:bg-[#fafafa] ${n.read ? "" : "bg-[#fdecec]"}`}>
              <div className="text-sm font-medium">{n.title}</div>
              <div className="text-xs text-[#52525b] mt-0.5 leading-snug">{n.message}</div>
              <div className="text-[10px] font-mono text-[#a1a1aa] mt-1">{new Date(n.created_at).toLocaleString("it-IT")}</div>
            </Link>
          ))}
          {!data.notifications.length && <div className="px-4 py-8 text-center text-xs text-[#a1a1aa] font-mono">{T("Nessuna notifica")}</div>}
        </div>
      )}
    </div>
  );
};
